"use strict";

require("./_utility-hero");